// @flow

import bootbox from "./vendor/bootbox";
import {trans} from "./trans";

class Popup {
    static show_err(s: string, callback: () => void): void {
        bootbox.alert(s, callback);
    }

    static show_success(s: string, callback: () => void) {
        bootbox.alert(s, callback);
    }

    static ask_passwd(callbackFunc: (string) => void): void {
        bootbox.prompt({
            title: trans("Enter password"),
            inputType: "password",
            callback: function (result) {
                callbackFunc(result);
            }
        });
    }

    static ask_input(message: string, defaultValue: string, callbackFunc: (string) => void): void {
        bootbox.prompt({
            title: message,
            value: defaultValue,
            callback: function (result) {
                callbackFunc(result);
            }
        });
    }
}

export default Popup;
